
const common = {
  "nav.productos": "Products",
  "nav.proceso": "Process",
  "nav.empresa": "Company",
  "nav.contactar": "Contact",

  "hero.title": "Costa Rican quality without borders",
  "hero.subtitle": "Exporters of processed agricultural products with international standards",
  "hero.cta": "Request Information",
  "hero.badge": "Exporting to 4 continents",

  "experience.title": "+30 years of experience in the market",
  "experience.subtitle": "Our team has more than three decades working hand in hand with local producers and developing food solutions for international markets.",
  "experience.story": "Our work team has more than 30 years of experience in the agro-industrial sector, building direct relationships with local producers and developing production processes that guarantee quality, safety and traceability in each product.",
  "experience.backing.title": "Our backing includes:",
  "experience.backing.item1": "More than 30 years of experience in the agro-industrial sector",
  "experience.backing.item2": "Direct relationship with local producers and stable supply",
  "experience.backing.item3": "Quality, safety and traceability processes",
  "experience.backing.item4": "Export experience and compliance with international requirements",
  "experience.backing.item5": "Flexibility in presentations and volumes according to the client",
  "experience.who.title": "Who We Are",
  "experience.who.desc1": "We are an agro-industrial company focused on the production of canned foods that uses raw materials purchased directly from local farming families.",
  "experience.who.desc2": "Each food we produce and package represents the joint work between our company and the producers who are part of our value chain.",
  "experience.who.desc3": "Our commitment is to transform Costa Rica's agricultural wealth into high-quality products ready for export.",

  "value.tag": "Why Choose Us",
  "value.title": "Quality, Sustainability and Trust",
  "value.subtitle": "We work directly with Costa Rican farming families to offer innovative food solutions",
  "value.b1.title": "Responsible Sourcing",
  "value.b1.desc": "We buy directly from local farming families, ensuring traceability and fair trade",
  "value.b2.title": "International Standards",
  "value.b2.desc": "Modern processing plant with quality controls that meet global regulations",
  "value.b3.title": "Export Experience",
  "value.b3.desc": "Consolidated presence in South America, North America, Europe and Asia",
  "value.b4.title": "Major Presence",
  "value.b4.desc": "Wide presence in American chains such as Walmart, HEB, Whole Foods, Publix...",

  "features.tag": "Our Capabilities",
  "features.title": "Infrastructure and Product Versatility",
  "features.f1.title": "Processing Plant",
  "features.f1.desc": "Facilities equipped with technology and certified quality control systems to ensure safety and traceability",
  "features.f1.p1": "International certifications",
  "features.f1.p2": "Temperature controls",
  "features.f1.p3": "Internal laboratory",
  "features.f2.title": "Multiple Cuts and Presentations",
  "features.f2.desc": "We offer whole hearts of palm, rice cut, linguini, puree, lasagna and angel hair, adapting to each market's needs",
  "features.f2.p1": "Constant innovation",
  "features.f2.p2": "Custom development",
  "features.f2.p3": "Technical advisory",
  "features.f3.title": "Flexible Packaging Options",
  "features.f3.desc": "Can and Glass available according to client preferences and destination market requirements",
  "features.f3.p1": "Custom labeling",
  "features.f3.p2": "Private label",
  "features.f3.p3": "Different sizes",

  "social.tag": "Our Origin",
  "social.title": "Why Costa Rica?",
  "social.desc": "Costa Rica is recognized worldwide for its biodiversity, agricultural excellence and commitment to sustainability. Our operations are located in Sarapiquí, a region known for its fertile land and rich natural environment.",
  "social.f1.title": "World Leader in Biodiversity",
  "social.f1.desc": "5% of biodiversity in 0.03% of the earth's surface",
  "social.f2.title": "Pioneer in Sustainability",
  "social.f2.desc": "Carbon neutral commitment and leader in renewable energy",
  "social.f3.title": "Agricultural Excellence",
  "social.f3.desc": "Fertile volcanic soils and ideal tropical climate",
  "social.s1.value": "30+",
  "social.s1.label": "YEARS OF EXPERIENCE",
  "social.s2.value": "5",
  "social.s2.label": "CONTINENTS SERVED",
  "social.s3.value": "100%",
  "social.s3.label": "LOCAL SOURCING",
  "social.s4.label": "EXPORT READY",

  "process.tag": "Our Process",
  "process.title": "From Our Field to the World in 3 Steps",
  "process.s1.title": "Local Sourcing",
  "process.s1.desc": "We purchase raw materials directly from Costa Rican producers, ensuring freshness and traceability from the origin",
  "process.s2.title": "Certified Processing",
  "process.s2.desc": "We transform and package under international quality and food safety standards",
  "process.s3.title": "Global Export",
  "process.s3.desc": "We deliver on time to major international markets with specialized logistics",

  "products.tag": "Our Products",
  "products.title": "Diversified Export Portfolio",
  "products.subtitle": "From hearts of palm in multiple presentations to tropical fruits, cassava, pulps and preserves",
  "products.note": "** Certified for handling and processing of organic hearts of palm and pineapple.",

  "products.cat1.title": "Heart of Palm",
  "products.cat1.opt1": "Mashed Heart of Palm",
  "products.cat1.opt2": "Rice Heart of Palm",
  "products.cat1.opt3": "Angel Hair Heart of Palm Pasta",

  "products.cat2.title": "Pineapple",
  "products.cat2.opt1": "Crushed Pineapple",
  "products.cat2.opt2": "Pineapple Chunks",
  "products.cat2.opt3": "Pineapple Slices",

  "products.cat3.title": "Whole Heart of Palm",
  "products.cat3.opt1": "Whole Heart of Palm",
  "products.cat3.opt2": "Double Decker Heart of Palm",
  "products.cat3.opt3": "Heart of Palm Slices",
  "products.cat3.opt4": "Heart of Palm Chunks",

  "pricing.title": "Customized Solutions for Every Client",
  "pricing.desc": "We understand that each market and trade partner has unique needs. Our prices and conditions adapt according to volume, presentation, packaging and destination.",
  "pricing.p1": "Volume and frequency-based quotes",
  "pricing.p2": "Flexibility in presentations and packaging",
  "pricing.p3": "Advisory to optimize logistics costs",
  "pricing.cta": "Request Quote",

  "cta.title": "Ready to Export Costa Rican Quality?",
  "cta.desc": "Let's build a long-term business relationship based on trust and excellence",
  "cta.button": "Contact Now",
  "cta.email": "Or write to us at",
  "cta.badge1": "Quick response",
  "cta.badge2": "Personalized advisory",
  "cta.badge3": "Samples available",

  "footer.tagline": "Costa Rican exporters of premium processed foods",
  "footer.productos": "PRODUCTS",
  "footer.empresa": "COMPANY",
  "footer.contacto": "CONTACT",
  "footer.porQueElegirnos": "Why Choose Us",
  "footer.capacidades": "Capabilities",
  "footer.porQueCR": "Why Costa Rica",
  "footer.proceso": "Our Process",
  "footer.productosLink": "Products",
  "footer.soluciones": "Solutions",
  "footer.contactoLink": "Contact",
  "footer.productPalmito": "Heart of Palm",
  "footer.productPina": "Pineapple",
  "footer.derechos": "© 2025 PPP Exports. All rights reserved.",

  "modal.title": "Contact Us",
  "modal.nombre": "Full name *",
  "modal.empresa": "Company *",
  "modal.email": "Email *",
  "modal.telefono": "Phone",
  "modal.pais": "Country *",
  "modal.mensaje": "Message *",
  "modal.placeholder": "Tell us about your import needs...",
  "modal.chars": "characters",
  "modal.success": "Message sent successfully! We will get in touch soon.",
  "modal.error": "There was an error sending the message. Please try again.",
  "modal.sending": "Sending...",
  "modal.send": "Send Message"
};

export default common;
